import { Service, ServiceCodes } from '@checkout-v2/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomCheckoutState, StateWithCustomCheckout } from '../checkout-state';
import { getCustomCheckoutState } from './feature.selector';

export const getServicesState: MemoizedSelector<
  StateWithCustomCheckout,
  StateUtils.LoaderState<Service[]>
> = createSelector(getCustomCheckoutState, (state: CustomCheckoutState) => state.services);

export const getServices: MemoizedSelector<StateWithCustomCheckout, Service[]> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderValueSelector(state.services) || [],
);

export const getServicesError: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderErrorSelector(state.services),
);

export const getServicesSuccess: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderSuccessSelector(state.services),
);

export const getServicesLoading: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderLoadingSelector(state.services),
);

export const getSelectedServiceId: MemoizedSelector<StateWithCustomCheckout, ServiceCodes | undefined> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => state.activeModes.serviceId,
);

export const getSelectedService: MemoizedSelector<StateWithCustomCheckout, Service | undefined> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => {
    const selectedServiceCode = state.activeModes.serviceId;
    const servicesList = state.services.value ?? [];

    if (!selectedServiceCode || !servicesList.length) {
      return undefined;
    }

    return servicesList.find((service) => service.code === selectedServiceCode);
  },
);
